import { render } from "./QuickActionsFab.vue?vue&type=template&id=8010cf7e&scoped=true"
import script from "./QuickActionsFab.vue?vue&type=script&lang=js"
export * from "./QuickActionsFab.vue?vue&type=script&lang=js"

import "./QuickActionsFab.vue?vue&type=style&index=0&id=8010cf7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\Account\\web\\Medical-Account-Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8010cf7e"]])

export default __exports__